type BurgerIconProps = {
  onClick: () => void;
};

export const BurgerIcon: React.FC<BurgerIconProps> = ({ onClick }) => {
  return (
    <svg
      width="32"
      height="32"
      fill="none"
      onClick={onClick}
      viewBox="0 0 32 32"
      className="cursor-pointer"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M24 10L8 10"
        stroke="white"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <path
        d="M24 16H8"
        stroke="white"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <path
        d="M24 22H8"
        stroke="white"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
    </svg>
  );
};
